import { CropPickerComposition } from '@codeleap/web'
import { createStyles } from '@codeleap/styles'
import { StyleRegistry } from '../styles'

const createCropPickerVariant = createStyles<CropPickerComposition>

export const CropPickerStyles = {
  default: createCropPickerVariant(theme => ({
    previewSize: {
      minWidth: 300,
      minHeight: 300,
      maxHeight: '70vh',
      [theme.media.down('mobile')]: {
        minWidth: 250,
        minHeight: 250,
        maxHeight: 'unset',
        maxWidth: '80vh',
      },
    },
    confirmButtonWrapper: {
      ...theme.presets.fullWidth,
    },
    modalCloseButtonTouchableWrapper: {
      border: 'none',
    },
    modalBox: {
      display: 'flex',
      margin: 'auto',
    },
  })),
}

StyleRegistry.registerVariants('CropPicker', CropPickerStyles)
